import { ApolloClient } from "@apollo/client/core";
import { gql } from "graphql-tag";
import pick from "lodash/pick";

import { transformCamelToSnake } from "lib/stringFunctions";
import { UserBookSerializersUserBook } from "types/serializers";
import { NewUserBookType } from "types/UserBookType";

import { editFields } from "../constants";

const insertUserBookQuery = `
  mutation CreateUserBook($object: UserBookCreateInput!) {
    insertResponse: insert_user_book(object: $object) {
      error
      userBook: user_book {
        ...UserBookFragment
      }
    }
  }
`;
const insertUserBookQueryCompiled = gql(insertUserBookQuery);

const insertFields = ["book_id", ...editFields];

export async function insertUserBook({
  client,
  userBook,
  userDate,
}: {
  client: ApolloClient<any>;
  userBook: NewUserBookType;
  userDate?: string;
}): Promise<UserBookSerializersUserBook> {
  const objectCamel = transformCamelToSnake(userBook);
  const object = pick(objectCamel, insertFields);

  if (userDate) {
    object.user_date = userDate;
  }

  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: insertUserBookQueryCompiled,
        variables: {
          object,
        },
      })
      .then(result => {
        if (result.data.insertResponse.error) {
          reject(result.data.insertResponse.error);
        } else {
          resolve(result.data.insertResponse.userBook);
        }
      })
      .catch(e => {
        reject(e.message);
      });
  });
}
